import { emit, events } from '@estee/elc-service-bus';

export class BookVirtualAppointmentClickedUseCase {
    private isVirtualCounterRequested: boolean = true;

    public execute() {
        emit(events.BOOK_VIRTUAL_APPOINTMENT_CLICKED, {
            isVirtual: this.isVirtualCounterRequested
        });
    }
}
